import React from 'react'
import { Form, Label, Input } from "reactstrap";
import { formatDate } from "../../../../Utils//format-date.js";
import './Create-Goal.css'


const CreateGoal = (props) => {
    return (
        <div className='create-goal-modal'>
            <Form>
                <Label>ASSESSMENT DATE</Label>
                <Input readOnly
                    value={formatDate(props.date)}
                />
                <Label>ORIENTATION</Label>
                <Input defaultValue='Choose An Option...' type='select'>
                    <option disabled> Choose An Option... </option>
                    <option>Achievement</option>
                    <option>Relationship</option>
                    <option>Nurturing</option>
                    <option>Leadership</option>
                    <option>Learning</option>
                </Input>
                <Label>MY WORKSHEET NAME</Label>
                <Input />
            </Form>
            <div className='buttons'>
                <button onClick={props.handleModalClose} className='cancel-button'>CANCEL</button>
                <button onClick={props.handleModalClose} className='submit-button'>SUBMIT</button>
            </div>
        </div>
    )
}

export default CreateGoal



// WEBPACK FOOTER //
// ./src/new/Dashboard/Admin/Goal-Setting-Worksheets/Create-Goal-Modal/Create-Goal.jsx